import Seo from "../Seo/Seo";
import BgSlider from "../Hero/bg";
import AboutCenter from "../About/AboutCenter";
import AboutLeft from "../About/aboutLeft";
import AboutRight from "../About/aboutRight";
import {Link} from "react-router-dom";

export default function Apropos() {
    return <>
        <Seo
            title="À propos | Provence Paie - Expert paie et RH pour experts-comptables"
            description="Découvrez Provence Paie : un cabinet social en Provence exclusivement dédié aux experts-comptables, avec un service de marque blanche, conformité et support RH personnalisés."
            pathname="/ProvencePaie"
        />
        <BgSlider
            title="PROVENCE PAIE"
            subtitle="A Propos"
        />
        <AboutCenter
            Title={<>
                PROVENCE PAIE :<br />
                <h3>L’Excellence Paie & RH dédiée aux Experts-Comptables</h3>
            </>}
            Subtitle="Simplifiez vos missions sociales avec un partenaire de confiance, né de l’expertise comptable."


        >

            <p>
                Situé à <strong>Cavaillon,</strong> au cœur de la Provence, PROVENCE PAIE est un cabinet de gestion sociale
                exclusivement dédié à l’accompagnement des cabinets d’expertise comptable. Nous ne sommes pas
                seulement un prestataire ; nous sommes le prolongement de votre pôle social.
            </p>

        </AboutCenter>
        <AboutLeft
            Title=""
            Subtitle="Une Vision d’Experts pour des Experts"
            Image={`${process.env.PUBLIC_URL}/images/_DSF1167.jpg`}
        >
            <p>
                Fondé par des professionnels du chiffre, <strong>PROVENCE PAIE</strong> comprend vos enjeux, vos contraintes et
                l'exigence de votre métier.
            </p>
            <ul className="about-team">
                <li><strong>Mr Moslim NAJI, </strong>Expert-comptable et Commissaire aux comptes.</li>
                <li><strong>Mr Bouazza BARI, </strong>Directeur de cabinet d’expertise comptable.</li>
            </ul>
            <p>
                Sous la direction de<strong> Mme Salma NAJI IDRISSI BOUANANI</strong>, Responsable d’agence, notre équipe
                apporte une réponse technique et opérationnelle aux cabinets souhaitant externaliser leur production
                sociale en toute sécurité.
            </p>

        </AboutLeft>
        
        <AboutRight
            Title=""
            Subtitle={<>La "Marque Blanche" : Votre Solution Clé en Main</>}
            Image={`${process.env.PUBLIC_URL}/images/_DSF1190.jpg`}
        >
            <p>
                Nous avons conçu un système en <strong>marque blanche</strong> qui vous permet d’intégrer une solution de gestion
                sociale performante, entièrement à votre image.
            </p>
            <p>
                Le bénéfice pour votre cabinet ? Vous offrez à vos clients une expérience fluide et une expertise de
                haut niveau sans avoir à supporter les coûts et la complexité liés au développement d’un pôle social
                interne ou d'un système propriétaire. <strong>Votre technologie, notre expertise, votre image</strong>.
            </p>

        </AboutRight>
        <AboutCenter
            Title={<>
                Nos Services:<br /> <h3>Un Accompagnement à 360°</h3>
            </>}
            Subtitle="Simplifiez vos missions sociales avec un partenaire de confiance, né de l’expertise comptable."


        >

            <p>
                Situé à <strong>Cavaillon,</strong> au cœur de la Provence, PROVENCE PAIE est un cabinet de gestion sociale
                exclusivement dédié à l’accompagnement des cabinets d’expertise comptable. Nous ne sommes pas
                seulement un prestataire ; nous sommes le prolongement de votre pôle social.
            </p>
            <Link to="/Mission" className="btn-more">Nos Services</Link>
        </AboutCenter>
            <AboutLeft
                Title=""
                Subtitle="Pourquoi choisir PROVENCE PAIE ?"
                Image={`${process.env.PUBLIC_URL}/images/_DSF1174.jpg`}
            >

                <ul className="about-team">
                    <li><strong>Exclusivité : </strong>Nous travaillons uniquement avec les experts-comptables. Aucune concurrence
                        directe avec vos clients.
                    </li>
                    <li><strong>Sérénité : </strong>Une veille juridique constante pour garantir la conformité de chaque bulletin de
                        paie.
                    </li>
                    <li><strong>Proximité : </strong>Une agence à taille humaine basée à Cavaillon, réactive et à l'écoute.
                    </li>
                </ul>
                <p>
                    <strong> Contactez-nous pour une collaboration durable</strong><br/>
                    Venez nous rencontrer ou échangeons sur vos besoins d'externalisation <br/>
                    <strong> Ensemble, transformons votre pôle social en un levier de rentabilité.</strong><br/>
                </p>

            </AboutLeft>


    </>
}